import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dAnalytics$dTypes$dVisitPage from "../Restaumatic.Analytics.Types.VisitPage/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const priceIsSymbol = {reflectSymbol: () => "price"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const selectedOptionIsSymbol = {reflectSymbol: () => "selectedOption"};
const selectedValueIsSymbol = {reflectSymbol: () => "selectedValue"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const affiliationIsSymbol = {reflectSymbol: () => "affiliation"};
const shippingIsSymbol = {reflectSymbol: () => "shipping"};
const couponIsSymbol = {reflectSymbol: () => "coupon"};
const sum = /* #__PURE__ */ Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0);
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther2 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const encodeWithOptionsOther3 = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(quantityIsSymbol)({
    encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
  }))(priceIsSymbol)(encodeWithOptionsOther))({reflectSymbol: () => "item_name"})(encodeWithOptionsOther1))({reflectSymbol: () => "item_list_id"})(encodeWithOptionsOther2))({
    reflectSymbol: () => "item_category"
  })(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
  return {encodeWithOptions: v => encode1};
})();
const currencyIsSymbol = {reflectSymbol: () => "currency"};
const encode = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
  reflectSymbol: () => "value"
})(encodeWithOptionsOther))(itemsIsSymbol)(encodeWithOptionsOther3))(currencyIsSymbol)(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const encode2 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
  reflectSymbol: () => "value"
})(encodeWithOptionsOther))({reflectSymbol: () => "transaction_id"})(encodeWithOptionsOther1))(shippingIsSymbol)(encodeWithOptionsOther))(itemsIsSymbol)(encodeWithOptionsOther3))(currencyIsSymbol)(encodeWithOptionsOther1))(couponIsSymbol)(encodeWithOptionsOther2))(affiliationIsSymbol)(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const encode3 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(selectedValueIsSymbol)(encodeWithOptionsOther1))(selectedOptionIsSymbol)(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const encode4 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "exp_variant_string"})(encodeWithOptionsOther1).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const itemValue = item => Data$dInt.toNumber(Data$dRecord.unsafeGet("price")(item)) / 100.0 * Data$dInt.toNumber(Data$dRecord.unsafeGet("quantity")(item));
const convertItem = item => (
  {
    item_name: Data$dRecord.unsafeGet("name")(item),
    quantity: Data$dRecord.unsafeGet("quantity")(item),
    price: Data$dInt.toNumber(Data$dRecord.unsafeGet("price")(item)) / 100.0,
    item_category: Data$dRecord.unsafeGet("category")(item),
    item_list_id: (() => {
      const $0 = Data$dRecord.unsafeGet("list")(item);
      if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show($0._1)); }
      return Data$dMaybe.Nothing;
    })()
  }
);
const toPlatformEvent = currency => v => {
  if (v.tag === "AddToCart") { return Data$dMaybe.$Maybe("Just", {name: "add_to_cart", value: encode({currency, value: itemValue(v._1), items: [convertItem(v._1)]})}); }
  if (v.tag === "LocateMe") { return Data$dMaybe.$Maybe("Just", {name: "locate_me", value: []}); }
  if (v.tag === "RemoveFromCart") { return Data$dMaybe.$Maybe("Just", {name: "remove_from_cart", value: encode({currency, value: itemValue(v._1), items: [convertItem(v._1)]})}); }
  if (v.tag === "BeginCheckout") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "begin_checkout",
        value: encode({
          items: Data$dFunctor.arrayMap(convertItem)(Data$dRecord.unsafeGet("items")(v._1)),
          value: sum(Data$dFunctor.arrayMap(itemValue)(Data$dRecord.unsafeGet("items")(v._1))),
          currency
        })
      }
    );
  }
  if (v.tag === "Purchase") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "purchase",
        value: encode2({
          items: Data$dFunctor.arrayMap(convertItem)(Data$dRecord.unsafeGet("items")(v._1)),
          value: Data$dInt.toNumber(Data$dRecord.unsafeGet("total")(v._1)) / 100.0,
          currency,
          affiliation: Data$dRecord.unsafeGet("affiliation")(v._1),
          shipping: Data$dInt.toNumber(Data$dRecord.unsafeGet("shipping")(v._1)) / 100.0,
          transaction_id: Data$dRecord.unsafeGet("transactionId")(v._1),
          coupon: Data$dRecord.unsafeGet("coupon")(v._1)
        })
      }
    );
  }
  if (v.tag === "SetCheckoutOption") {
    return Data$dMaybe.$Maybe(
      "Just",
      {name: "set_checkout_option", value: encode3({selectedOption: Data$dRecord.unsafeGet("selectedOption")(v._1), selectedValue: Data$dRecord.unsafeGet("selectedValue")(v._1)})}
    );
  }
  if (v.tag === "ExperienceImpression") {
    return Data$dMaybe.$Maybe(
      "Just",
      {name: "experience_impression", value: encode4({exp_variant_string: "RE-" + Data$dRecord.unsafeGet("experiment")(v._1) + "-" + Data$dRecord.unsafeGet("variant")(v._1)})}
    );
  }
  if (v.tag === "VisitPage") { return Data$dMaybe.$Maybe("Just", {name: "visit_page", value: Restaumatic$dAnalytics$dTypes$dVisitPage.encodeVisitPage.encode(v._1)}); }
  if (v.tag === "ReviewGoogleLinkShown") { return Data$dMaybe.$Maybe("Just", {name: "review_google_link_shown", value: []}); }
  if (v.tag === "NotOverlappingDishes") { return Data$dMaybe.Nothing; }
  if (v.tag === "SuggestionResult") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
export {
  affiliationIsSymbol,
  convertItem,
  couponIsSymbol,
  currencyIsSymbol,
  encode,
  encode2,
  encode3,
  encode4,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  itemValue,
  itemsIsSymbol,
  priceIsSymbol,
  quantityIsSymbol,
  selectedOptionIsSymbol,
  selectedValueIsSymbol,
  shippingIsSymbol,
  sum,
  toPlatformEvent
};
